import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_flight_summary_meta';
export const route = 'checkout_flight_summary_meta/[token]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/CheckoutFlightSummaryMeta')));